import { Configurations } from '../../Utils/Configurations';
import React, { Component } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import './User-Balance-Details.scss';
import IntlCurrencyInput from "react-intl-currency-input";
import axios from 'axios';
import update from 'immutability-helper';

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};


class UserBalanceDetails extends Component {
    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.salvarLancamento = this.salvarLancamento.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal(this);
        this.getUserExtract = this.getUserExtract.bind(this);
        this.onChangeModalInput = this.onChangeModalInput.bind(this);

        this.state = {
            openModal: false,
            valor: null,
            tipoLancamento: 1,
            observacoes: "",
            isLoadingNovoLancamento: false,
            userExtract: [],
            userBalance: 0,
            loadingBalance: false,
            newBalance: {
                valor: 0,
                tipoLancamento: 1,
                obs: ""
            }
        }

        this.Configurations = new Configurations();

        this.columnsDetalhesSaldo = [
            {
                Header: '#',
                accessor: 'idExtrato',
                width: 65,
                className: 'text-center',
            },
            {
                Header: 'Pedido origem',
                accessor: 'idPedido',
                className: 'text-center',
                width: 75,
                // Cell: row => (<span>{!!row.value ? row.value.map(item => {
                //     return (
                //         <p className="m-0">{item}</p>
                //     )
                // }) : '-'}</span>)

            },
            {
                Header: 'Valor',
                accessor: 'valor',
                className: 'text-center',
                width: 80,
                Cell: row => {
                    const _verificaStatusSaldo = row.value,
                        _saldoStatus = _verificaStatusSaldo < 0 ? "text-danger" : "text-success";
                    return (<span className={_saldoStatus}>R$ {!!row.value ? row.value.toFixed(2).toString().replace('.', ',') : "0,00"}</span>
                    )
                }
            },
            {
                Header: 'Produto',
                accessor: 'sigla',
                className: 'text-center',
                width: 65,
                Cell: row => (<span>{row.value}</span>)

            },
            {
                Header: 'Edição',
                accessor: 'numEdicao',
                className: 'text-center',
                width: 60,
                Cell: row => (<span>{row.value}</span>)

            },
            {
                Header: 'Dt. Entrega',
                accessor: 'dtEntrega',
                className: 'text-center',
                width: 90,
                Cell: row => (<span>{row.value ? moment(row.value).format('DD/MM/YY') : ""}</span>)

            },
            {
                Header: 'Dt. lançamento',
                accessor: 'dtCriacao',
                className: 'text-center',
                width: 90,
                Cell: row => (<span>{moment(row.value).format('DD/MM/YY HH:mm')}</span>)

            },
            {
                Header: 'Tipo lançamento',
                accessor: 'tipoOperacao',
                className: 'text-center',
                width: 220,
                Cell: row => (<small>{!!row.value ? (row.value) : '-'}</small>)

            },
            {
                Header: 'Observações',
                accessor: 'obs',
                className: 'text-left observacoes',
                Cell: row => (<small>{!!row.value ? (row.value) : '-'}</small>)
            },
            {
                Header: 'Usuário',
                accessor: 'userFukyo',
                width: 100,
                className: 'text-center',
            }
        ]
        // this.getUserExtract({});

    }


    getUserExtract(o) {
        this.setState({ loadingBalance: true });
        const _params = [];

        if (!o.pageSize) {
            o.pageSize = 50;
            _params.push(`qtdItens=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = 1;
            _params.push(`pagina=${o.page}`);
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
        }

        const _userExtract = axios.get(this.Configurations.apiBasePath + `/saldo/usuario/extrato/${this.props.match.params.idUsuario}?${_params.join('&')}`);

        _userExtract.then(response => {
            this.setState({
                userExtract: response.data.extratoSaldo,
                userBalance: response.data.saldo,
                user: response.data.usuario,
                pages: response.data.paginacao.totalPaginas,
                loadingBalance: false
            });
        }).catch(this.handleError)
    }

    toggleModal() {
        this.setState({
            openModal: !this.state.openModal

        })
    }

    onChangeInput(e, valueInputValor, maskedValue) {
        const _name = e.target.name,
            _value = e.target.name === "valor" ? valueInputValor : e.target.value;
        // _value = e.target.value
        this.setState({ [_name]: _value })
    }

    onChangeModalInput(e, value, maskedValue) {
        const _name = e.target.name;
        let _value;
        switch (e.target.name) {
            case "valor":
                _value = parseFloat(value);
                break;
            case "tipoLancamento":
                _value = parseInt(e.target.value);
                break;
            default:
                _value = e.target.value;
                break;
        }

        this.setState({ newBalance: update(this.state.newBalance, { [_name]: { $set: _value } }) });
    }

    salvarLancamento() {
        this.setState({ isLoadingNovoLancamento: true });
        const _newBalance = this.state.newBalance;
        const _novoLancamento = axios.post(this.Configurations.apiBasePath + `/saldo/usuario/lancamento/${this.props.match.params.idUsuario}`, {
            "lancamento": {
                valor: _newBalance.tipoLancamento === 0 ? _newBalance.valor * (-1) : _newBalance.valor,
                obs: _newBalance.obs
            }
        });

        _novoLancamento.then(response => {
            this.setState({
                isLoadingNovoLancamento: false,
                newBalance: {
                    valor: 0,
                    tipoLancamento: 1,
                    obs: ""
                }
            }, () => {
                this.getUserExtract({});
                this.toggleModal();
            });
        }).catch(err => {
            this.setState({
                isLoadingNovoLancamento: false,
                hasError: true
            });
        });
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    render() {
        return (
            <div className="row detalhes-saldo">
                <div className="col-6 text-left mt-2">
                    <h2>Detalhes do saldo</h2>
                </div>
                <div className="col-6 text-right mt-2">
                    <button onClick={() => this.props.history.push(`/assinante/${this.props.match.params.idUsuario}`)}
                        className=" btn btn-outline-secondary mr-4" type="button" name="dados-usuario">Dados do usuário</button>
                    <button onClick={this.toggleModal} className=" btn btn-outline-success" type="button" name="novo-lancamento">Novo lançamento</button>
                </div>
                <div className="col-12 text-left mt-2">
                    <h4>{this.state.user ? this.state.user.nome : ""}</h4>
                </div>
                <div className="col-12 text-center mt-2">
                    <h3 ><strong>
                        Saldo:  <span className={this.state.userBalance > 0 ? "text-success" : "text-danger"}>
                            R$ {!!this.state.userBalance ? this.state.userBalance.toFixed(2).toString().replace('.', ',') : "0,00"}</span>
                    </strong></h3>
                </div>

                <div className="col-12">
                    <div className="card mt-3">
                        <div className="card-body p-0">
                            <ReactTable
                                data={this.state.userExtract}
                                columns={this.columnsDetalhesSaldo}
                                onFetchData={this.getUserExtract}
                                manual
                                defaultPageSize={10}
                                pages={this.state.pages}
                                headerClassName="ebs-table-header"
                                className="-striped -highlight"
                                previousText='Anterior'
                                nextText='Próximo'
                                loadingText='Carregando...'
                                noDataText='Nenhum item encontrado.'
                                pageText='Página'
                                ofText='de'
                                rowsText='linhas'
                            />
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.openModal} toggle={this.toggleModal} className="modal-lancamento">
                    <ModalHeader toggle={this.toggleModal}>Novo lançamento</ModalHeader>
                    <ModalBody>

                        <div className="row lancamentos">
                            <div className="col-5">
                                <label>Valor do lançamento</label>
                                {/* <input autoComplete="off" name="valor" className="form-control input-novo-lancamento" type="number" value={this.state.valor} onChange={this.onChangeInput} /> */}
                                <IntlCurrencyInput currency="BRL" config={currencyConfig}
                                    autoComplete="off" name="valor"
                                    className="form-control input-novo-lancamento"
                                    // type="number" 
                                    value={this.state.newBalance.valor}
                                    onChange={this.onChangeModalInput}
                                />
                            </div>

                            <div className="col-6 offset-1">
                                <div className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="cred" name="tipoLancamento" className="custom-control-input" checked={parseInt(this.state.newBalance.tipoLancamento, 10) === 1} value={"1"} onChange={this.onChangeModalInput} />
                                    <label className="custom-control-label" htmlFor="cred">Crédito</label>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="deb" name="tipoLancamento" className="custom-control-input" checked={parseInt(this.state.newBalance.tipoLancamento, 10) === 0} value={"0"} onChange={this.onChangeModalInput} />
                                    <label className="custom-control-label" htmlFor="deb">Débito</label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 mt-4">
                                <label>Observações</label>
                                <textarea autoComplete="off" name="obs" className="form-control input-observacoes" type="text" value={this.state.newBalance.obs} rows={3} onChange={this.onChangeModalInput} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 text-center mt-3">
                                {this.state.isLoadingNovoLancamento ? (
                                    <div className="spinner-border text-primary" role="status" />
                                ) : (
                                    <div>
                                        <button onClick={this.salvarLancamento} disabled={this.state.newBalance.valor === null || parseFloat(this.state.newBalance.valor) === 0} className="btn btn-outline-success">Salvar</button>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-12">
                                {JSON.stringify(this.state.newBalance)}
                            </div>
                        </div> */}
                    </ModalBody>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div >


        )
    }
}

export default UserBalanceDetails;